/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type CANT_DELETE_TASK_REASON = "BLOCKED_BY_SUBTASK" | "GITHUB" | "HAS_INVOICED_TIME" | "HAS_LOCKED_TIME" | "HAS_OTHER_PEOPLES_TIME_REGS" | "HAS_TIME_REGS" | "JIRA" | "NO_USER_TYPE" | "UNIT4" | "%future added value";
export type DEPENDENCY_TYPE = "CANNOT_BE_COMPLETED" | "CANNOT_START" | "%future added value";
export type PROGRAM_BUDGET_TYPE = "CAPPED" | "FIXED_PRICE" | "UNCAPPED" | "%future added value";
export type PROJECT_STATUS = "DONE" | "HALTED" | "OPPORTUNITY" | "PLANNING" | "RUNNING" | "%future added value";
export type STATUS_CATEGORY = "DONE" | "INPROGRESS" | "TODO" | "%future added value";
export type taskModalV3_task = {
    readonly id: string;
    readonly userCanDeleteTask: boolean | null;
    readonly userCantDeleteTaskReason: CANT_DELETE_TASK_REASON | null;
    readonly fullAccessToProject: boolean | null;
    readonly approved: boolean | null;
    readonly name: string | null;
    readonly readOnly: {
        readonly isReadOnly: boolean | null;
    } | null;
    readonly coverFile: {
        readonly id: string;
    } | null;
    readonly parentTaskId: string | null;
    readonly parentTask: {
        readonly id: string;
        readonly companyTaskId: number | null;
        readonly name: string | null;
        readonly parentTask: {
            readonly id: string;
            readonly companyTaskId: number | null;
            readonly name: string | null;
        } | null;
    } | null;
    readonly hasChildren: boolean | null;
    readonly companyTaskId: number | null;
    readonly blocked: boolean | null;
    readonly bug: boolean | null;
    readonly billable: boolean | null;
    readonly highPriority: boolean | null;
    readonly startYear: number | null;
    readonly startMonth: number | null;
    readonly startDay: number | null;
    readonly description: string | null;
    readonly jiraId: string | null;
    readonly jiraKey: string | null;
    readonly gitlabIid: string | null;
    readonly vstsId: string | null;
    readonly pipedriveId: string | null;
    readonly isUnit4Task: boolean | null;
    readonly estimateForecast: number | null;
    readonly timeLeft: number | null;
    readonly deadlineDay: number | null;
    readonly deadlineMonth: number | null;
    readonly deadlineYear: number | null;
    readonly startFrom: string | null;
    readonly deadlineFrom: string | null;
    readonly gitlabServerIid: string | null;
    readonly hasLockedTime: boolean | null;
    readonly hasInvoicedTime: boolean | null;
    readonly favoured: boolean | null;
    readonly sageIntacctId: string | null;
    readonly progressDetails: {
        readonly progress: number | null;
    } | null;
    readonly followers: ReadonlyArray<{
        readonly id: string;
        readonly firstName: string | null;
        readonly lastName: string | null;
        readonly profilePictureId: string | null;
        readonly profilePictureDefaultId: number | null;
    } | null> | null;
    readonly taskLabels: ReadonlyArray<{
        readonly label: {
            readonly id: string;
            readonly name: string | null;
            readonly color: string | null;
        } | null;
    } | null> | null;
    readonly subTasks: {
        readonly edges: ReadonlyArray<{
            readonly node: {
                readonly id: string;
                readonly estimate: number | null;
                readonly done: boolean | null;
                readonly sortOrder: number | null;
                readonly name: string | null;
                readonly description: string | null;
                readonly startDay: number | null;
                readonly startMonth: number | null;
                readonly startYear: number | null;
                readonly endDay: number | null;
                readonly endMonth: number | null;
                readonly endYear: number | null;
                readonly startFrom: string | null;
                readonly endFrom: string | null;
                readonly role: {
                    readonly id: string;
                    readonly name: string | null;
                } | null;
                readonly person: {
                    readonly id: string;
                    readonly firstName: string | null;
                    readonly lastName: string | null;
                    readonly active: boolean | null;
                    readonly profilePictureId: string | null;
                    readonly profilePictureDefaultId: number | null;
                } | null;
            } | null;
        } | null> | null;
    } | null;
    readonly thisTaskDependsOn: {
        readonly edges: ReadonlyArray<{
            readonly node: {
                readonly id: string;
                readonly type: DEPENDENCY_TYPE | null;
                readonly completed: boolean | null;
                readonly taskDependsOnThis: {
                    readonly id: string;
                    readonly name: string | null;
                    readonly companyTaskId: number | null;
                    readonly startYear: number | null;
                    readonly startMonth: number | null;
                    readonly startDay: number | null;
                    readonly deadlineDay: number | null;
                    readonly deadlineMonth: number | null;
                    readonly deadlineYear: number | null;
                    readonly statusColumnV2: {
                        readonly id: string;
                        readonly category: STATUS_CATEGORY | null;
                    } | null;
                } | null;
                readonly thisDependsOnTask: {
                    readonly id: string;
                    readonly name: string | null;
                    readonly companyTaskId: number | null;
                    readonly startYear: number | null;
                    readonly startMonth: number | null;
                    readonly startDay: number | null;
                    readonly deadlineDay: number | null;
                    readonly deadlineMonth: number | null;
                    readonly deadlineYear: number | null;
                    readonly statusColumnV2: {
                        readonly id: string;
                        readonly category: STATUS_CATEGORY | null;
                    } | null;
                } | null;
            } | null;
        } | null> | null;
    } | null;
    readonly dependsOnThisTask: {
        readonly edges: ReadonlyArray<{
            readonly node: {
                readonly id: string;
                readonly type: DEPENDENCY_TYPE | null;
                readonly completed: boolean | null;
                readonly taskDependsOnThis: {
                    readonly id: string;
                    readonly name: string | null;
                    readonly companyTaskId: number | null;
                    readonly startYear: number | null;
                    readonly startMonth: number | null;
                    readonly startDay: number | null;
                    readonly deadlineDay: number | null;
                    readonly deadlineMonth: number | null;
                    readonly deadlineYear: number | null;
                    readonly statusColumnV2: {
                        readonly id: string;
                        readonly category: STATUS_CATEGORY | null;
                    } | null;
                } | null;
                readonly thisDependsOnTask: {
                    readonly id: string;
                    readonly name: string | null;
                    readonly companyTaskId: number | null;
                    readonly startYear: number | null;
                    readonly startMonth: number | null;
                    readonly startDay: number | null;
                    readonly deadlineDay: number | null;
                    readonly deadlineMonth: number | null;
                    readonly deadlineYear: number | null;
                    readonly statusColumnV2: {
                        readonly id: string;
                        readonly category: STATUS_CATEGORY | null;
                    } | null;
                } | null;
            } | null;
        } | null> | null;
    } | null;
    readonly repeatingTask: {
        readonly id: string;
        readonly repeatType: string | null;
        readonly monday: boolean | null;
        readonly tuesday: boolean | null;
        readonly wednesday: boolean | null;
        readonly thursday: boolean | null;
        readonly friday: boolean | null;
        readonly saturday: boolean | null;
        readonly sunday: boolean | null;
        readonly monthlyDay: number | null;
    } | null;
    readonly statusColumnV2: {
        readonly id: string;
        readonly name: string | null;
        readonly category: STATUS_CATEGORY | null;
        readonly projectGroupStatusColumnId: number | null;
    } | null;
    readonly phase: {
        readonly id: string;
        readonly name: string | null;
        readonly startYear: number | null;
        readonly startMonth: number | null;
        readonly startDay: number | null;
        readonly deadlineDay: number | null;
        readonly deadlineMonth: number | null;
        readonly deadlineYear: number | null;
    } | null;
    readonly sprint: {
        readonly id: string;
        readonly name: string | null;
        readonly startYear: number | null;
        readonly startMonth: number | null;
        readonly startDay: number | null;
        readonly endDay: number | null;
        readonly endMonth: number | null;
        readonly endYear: number | null;
    } | null;
    readonly assignedPersons: ReadonlyArray<{
        readonly id: string;
        readonly firstName: string | null;
        readonly lastName: string | null;
        readonly role: {
            readonly id: string;
            readonly name: string | null;
        } | null;
        readonly profilePictureId: string | null;
        readonly profilePictureDefaultId: number | null;
        readonly email: string | null;
    } | null> | null;
    readonly timeRegistrations: {
        readonly edges: ReadonlyArray<{
            readonly node: {
                readonly id: string;
                readonly invoiced: boolean | null;
                readonly xeroInvoiceId: string | null;
                readonly minutesRegistered: number | null;
                readonly lockedInPeriod: boolean | null;
            } | null;
        } | null> | null;
    } | null;
    readonly role: {
        readonly id: string;
        readonly name: string | null;
    } | null;
    readonly googleDriveFiles: {
        readonly edges: ReadonlyArray<{
            readonly node: {
                readonly id: string | null;
                readonly name: string | null;
                readonly link: string | null;
                readonly thumb: string | null;
            } | null;
        } | null> | null;
    } | null;
    readonly files: {
        readonly edges: ReadonlyArray<{
            readonly node: {
                readonly id: string;
                readonly name: string | null;
                readonly mimeType: string | null;
                readonly key: string | null;
                readonly size: number | null;
                readonly yearCreated: number | null;
                readonly monthCreated: number | null;
                readonly dayCreated: number | null;
                readonly hourCreated: number | null;
                readonly minuteCreated: number | null;
                readonly secondCreated: number | null;
                readonly person: {
                    readonly id: string;
                    readonly fullName: string | null;
                } | null;
            } | null;
        } | null> | null;
    } | null;
    readonly commentCount: number | null;
    readonly comments: {
        readonly edges: ReadonlyArray<{
            readonly node: {
                readonly id: string;
                readonly comment: string | null;
                readonly year: number | null;
                readonly month: number | null;
                readonly day: number | null;
                readonly hours: number | null;
                readonly minutes: number | null;
                readonly seconds: number | null;
                readonly person: {
                    readonly id: string;
                    readonly firstName: string | null;
                    readonly lastName: string | null;
                    readonly fullName: string | null;
                    readonly profilePictureId: string | null;
                    readonly profilePictureDefaultId: number | null;
                } | null;
            } | null;
        } | null> | null;
    } | null;
    readonly createdAt: string | null;
    readonly createdBy: {
        readonly id: string;
        readonly firstName: string | null;
        readonly lastName: string | null;
    } | null;
    readonly latestUiUpdateAt: string | null;
    readonly latestUiUpdateBy: {
        readonly id: string;
        readonly firstName: string | null;
        readonly lastName: string | null;
    } | null;
    readonly owner: {
        readonly id: string;
        readonly firstName: string | null;
        readonly lastName: string | null;
        readonly fullName: string | null;
        readonly profilePictureId: string | null;
        readonly profilePictureDefaultId: number | null;
        readonly role: {
            readonly id: string;
            readonly name: string | null;
        } | null;
    } | null;
    readonly project: {
        readonly id: string;
        readonly name: string | null;
        readonly useTaskOwner: boolean | null;
        readonly useTaskFollowers: boolean | null;
        readonly useTaskHierarchy: boolean | null;
        readonly projectStartYear: number | null;
        readonly projectStartMonth: number | null;
        readonly projectStartDay: number | null;
        readonly projectEndYear: number | null;
        readonly projectEndMonth: number | null;
        readonly projectEndDay: number | null;
        readonly status: PROJECT_STATUS | null;
        readonly projectColor: string | null;
        readonly isJiraProject: boolean | null;
        readonly jiraSubtaskType: string | null;
        readonly jiraCloudProject: {
            readonly id: string;
        } | null;
        readonly jiraCloudEpicIds: ReadonlyArray<string | null> | null;
        readonly jiraServerProject: {
            readonly id: string;
        } | null;
        readonly gitlabProjectName: string | null;
        readonly gitlabServerProjectName: string | null;
        readonly projectGroupId: string | null;
        readonly billable: boolean | null;
        readonly taskLevels: number | null;
        readonly companyProjectId: number | null;
        readonly customProjectId: string | null;
        readonly isProgramRevenueLocked: boolean | null;
        readonly programBudgetType: PROGRAM_BUDGET_TYPE | null;
        readonly program: {
            readonly name: string | null;
            readonly prefix: string | null;
            readonly budgetType: PROGRAM_BUDGET_TYPE | null;
            readonly members: {
                readonly edges: ReadonlyArray<{
                    readonly node: {
                        readonly role: string | null;
                        readonly person: {
                            readonly id: string;
                        } | null;
                    } | null;
                } | null> | null;
            } | null;
        } | null;
        readonly harvestProject: {
            readonly id: string;
        } | null;
        readonly manualProgressOnProjectEnabled: boolean | null;
        readonly manualProgressOnPhasesEnabled: boolean | null;
        readonly manualProgressOnTasksEnabled: boolean | null;
        readonly vstsProject: string | null;
        readonly vstsAccount: string | null;
        readonly vstsTwoWaySync: boolean | null;
        readonly sprintTimeBox: boolean | null;
        readonly estimationUnit: string | null;
        readonly remainingAutoCalculated: boolean | null;
        readonly rateCard: {
            readonly id: string;
            readonly disabledRoles: ReadonlyArray<{
                readonly id: string;
            } | null> | null;
        } | null;
        readonly projectPersons: {
            readonly edges: ReadonlyArray<{
                readonly node: {
                    readonly id: string;
                    readonly person: {
                        readonly id: string;
                        readonly firstName: string | null;
                        readonly lastName: string | null;
                        readonly fullName: string | null;
                        readonly profilePictureId: string | null;
                        readonly profilePictureDefaultId: number | null;
                        readonly active: boolean | null;
                        readonly permissions: ReadonlyArray<string | null> | null;
                        readonly harvestUser: boolean | null;
                    } | null;
                    readonly project: {
                        readonly id: string;
                    } | null;
                    readonly role: {
                        readonly id: string;
                        readonly name: string | null;
                    } | null;
                } | null;
            } | null> | null;
        } | null;
        readonly client: {
            readonly id: string;
            readonly name: string | null;
            readonly logoId: string | null;
            readonly logoDefaultId: number | null;
        } | null;
        readonly phases: {
            readonly edges: ReadonlyArray<{
                readonly node: {
                    readonly id: string;
                    readonly name: string | null;
                    readonly startYear: number | null;
                    readonly startMonth: number | null;
                    readonly startDay: number | null;
                    readonly deadlineYear: number | null;
                    readonly deadlineMonth: number | null;
                    readonly deadlineDay: number | null;
                } | null;
            } | null> | null;
        } | null;
        readonly statusColumnsV2: {
            readonly edges: ReadonlyArray<{
                readonly node: {
                    readonly id: string;
                    readonly name: string | null;
                    readonly category: STATUS_CATEGORY | null;
                    readonly order: number | null;
                    readonly jiraStatusId: string | null;
                    readonly adoState: string | null;
                    readonly projectGroupStatusColumnId: number | null;
                    readonly userActions: {
                        readonly canDelete: boolean | null;
                        readonly canDeleteWithTasks: boolean | null;
                        readonly canCreateTask: boolean | null;
                        readonly canRename: boolean | null;
                    } | null;
                } | null;
            } | null> | null;
        } | null;
        readonly sprints: {
            readonly edges: ReadonlyArray<{
                readonly node: {
                    readonly id: string;
                    readonly name: string | null;
                    readonly startYear: number | null;
                    readonly startMonth: number | null;
                    readonly startDay: number | null;
                    readonly endYear: number | null;
                    readonly endMonth: number | null;
                    readonly endDay: number | null;
                } | null;
            } | null> | null;
        } | null;
        readonly " $fragmentRefs": FragmentRefs<"DeprecatedProjectIndicatorJS_project">;
    } | null;
    readonly " $refType": "taskModalV3_task";
};
export type taskModalV3_task$data = taskModalV3_task;
export type taskModalV3_task$key = {
    readonly " $data"?: taskModalV3_task$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"taskModalV3_task">;
};



const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v2 = [
  (v0/*: any*/)
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "companyTaskId",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "billable",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "startYear",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "startMonth",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "startDay",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "deadlineDay",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "deadlineMonth",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "deadlineYear",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "startFrom",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "firstName",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastName",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "profilePictureId",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "profilePictureDefaultId",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "endDay",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "endMonth",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "endYear",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "concreteType": "Role",
  "kind": "LinkedField",
  "name": "role",
  "plural": false,
  "selections": [
    (v0/*: any*/),
    (v1/*: any*/)
  ],
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "active",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cursor",
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "endCursor",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasNextPage",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v25 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "category",
  "storageKey": null
},
v26 = [
  (v0/*: any*/),
  (v1/*: any*/),
  (v3/*: any*/),
  (v5/*: any*/),
  (v6/*: any*/),
  (v7/*: any*/),
  (v9/*: any*/),
  (v10/*: any*/),
  (v11/*: any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": "StatusColumnV2",
    "kind": "LinkedField",
    "name": "statusColumnV2",
    "plural": false,
    "selections": [
      (v0/*: any*/),
      (v25/*: any*/)
    ],
    "storageKey": null
  }
],
v27 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "DependencyTypeEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "DependencyType",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "type",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "completed",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Task",
            "kind": "LinkedField",
            "name": "taskDependsOnThis",
            "plural": false,
            "selections": (v26/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Task",
            "kind": "LinkedField",
            "name": "thisDependsOnTask",
            "plural": false,
            "selections": (v26/*: any*/),
            "storageKey": null
          },
          (v22/*: any*/)
        ],
        "storageKey": null
      },
      (v23/*: any*/)
    ],
    "storageKey": null
  },
  (v24/*: any*/)
],
v28 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "projectGroupStatusColumnId",
  "storageKey": null
},
v29 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "fullName",
  "storageKey": null
},
v30 = [
  (v0/*: any*/),
  (v13/*: any*/),
  (v14/*: any*/)
],
v31 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 10000
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": null,
        "cursor": null,
        "direction": "forward",
        "path": [
          "subTasks"
        ]
      },
      {
        "count": null,
        "cursor": null,
        "direction": "forward",
        "path": [
          "thisTaskDependsOn"
        ]
      },
      {
        "count": null,
        "cursor": null,
        "direction": "forward",
        "path": [
          "dependsOnThisTask"
        ]
      },
      {
        "count": null,
        "cursor": null,
        "direction": "forward",
        "path": [
          "timeRegistrations"
        ]
      },
      {
        "count": null,
        "cursor": null,
        "direction": "forward",
        "path": [
          "googleDriveFiles"
        ]
      },
      {
        "count": null,
        "cursor": null,
        "direction": "forward",
        "path": [
          "files"
        ]
      },
      {
        "count": null,
        "cursor": null,
        "direction": "forward",
        "path": [
          "comments"
        ]
      },
      {
        "count": null,
        "cursor": null,
        "direction": "forward",
        "path": [
          "project",
          "projectPersons"
        ]
      }
    ]
  },
  "name": "taskModalV3_task",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "userCanDeleteTask",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "userCantDeleteTaskReason",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "fullAccessToProject",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "approved",
      "storageKey": null
    },
    (v1/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "TaskReadOnly",
      "kind": "LinkedField",
      "name": "readOnly",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isReadOnly",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "File",
      "kind": "LinkedField",
      "name": "coverFile",
      "plural": false,
      "selections": (v2/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "parentTaskId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Task",
      "kind": "LinkedField",
      "name": "parentTask",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        (v3/*: any*/),
        (v1/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "Task",
          "kind": "LinkedField",
          "name": "parentTask",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            (v3/*: any*/),
            (v1/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasChildren",
      "storageKey": null
    },
    (v3/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "blocked",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "bug",
      "storageKey": null
    },
    (v4/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "highPriority",
      "storageKey": null
    },
    (v5/*: any*/),
    (v6/*: any*/),
    (v7/*: any*/),
    (v8/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "jiraId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "jiraKey",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "gitlabIid",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "vstsId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "pipedriveId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isUnit4Task",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "estimateForecast",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "timeLeft",
      "storageKey": null
    },
    (v9/*: any*/),
    (v10/*: any*/),
    (v11/*: any*/),
    (v12/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "deadlineFrom",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "gitlabServerIid",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasLockedTime",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasInvoicedTime",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "favoured",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "sageIntacctId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "TaskProgress",
      "kind": "LinkedField",
      "name": "progressDetails",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "progress",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Person",
      "kind": "LinkedField",
      "name": "followers",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        (v13/*: any*/),
        (v14/*: any*/),
        (v15/*: any*/),
        (v16/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "TaskLabel",
      "kind": "LinkedField",
      "name": "taskLabels",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Label",
          "kind": "LinkedField",
          "name": "label",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            (v1/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "color",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": "subTasks",
      "args": null,
      "concreteType": "SubTaskTypeConnection",
      "kind": "LinkedField",
      "name": "__Task_subTasks_connection",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "SubTaskTypeEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "SubTask",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "estimate",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "done",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "sortOrder",
                  "storageKey": null
                },
                (v1/*: any*/),
                (v8/*: any*/),
                (v7/*: any*/),
                (v6/*: any*/),
                (v5/*: any*/),
                (v17/*: any*/),
                (v18/*: any*/),
                (v19/*: any*/),
                (v12/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endFrom",
                  "storageKey": null
                },
                (v20/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Person",
                  "kind": "LinkedField",
                  "name": "person",
                  "plural": false,
                  "selections": [
                    (v0/*: any*/),
                    (v13/*: any*/),
                    (v14/*: any*/),
                    (v21/*: any*/),
                    (v15/*: any*/),
                    (v16/*: any*/)
                  ],
                  "storageKey": null
                },
                (v22/*: any*/)
              ],
              "storageKey": null
            },
            (v23/*: any*/)
          ],
          "storageKey": null
        },
        (v24/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": "thisTaskDependsOn",
      "args": null,
      "concreteType": "DependencyTypeConnection",
      "kind": "LinkedField",
      "name": "__Task_thisTaskDependsOn_connection",
      "plural": false,
      "selections": (v27/*: any*/),
      "storageKey": null
    },
    {
      "alias": "dependsOnThisTask",
      "args": null,
      "concreteType": "DependencyTypeConnection",
      "kind": "LinkedField",
      "name": "__Task_dependsOnThisTask_connection",
      "plural": false,
      "selections": (v27/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "RepeatingTask",
      "kind": "LinkedField",
      "name": "repeatingTask",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "repeatType",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "monday",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "tuesday",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "wednesday",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "thursday",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "friday",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "saturday",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "sunday",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "monthlyDay",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "StatusColumnV2",
      "kind": "LinkedField",
      "name": "statusColumnV2",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        (v1/*: any*/),
        (v25/*: any*/),
        (v28/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "PhaseType",
      "kind": "LinkedField",
      "name": "phase",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        (v1/*: any*/),
        (v5/*: any*/),
        (v6/*: any*/),
        (v7/*: any*/),
        (v9/*: any*/),
        (v10/*: any*/),
        (v11/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Sprint",
      "kind": "LinkedField",
      "name": "sprint",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        (v1/*: any*/),
        (v5/*: any*/),
        (v6/*: any*/),
        (v7/*: any*/),
        (v17/*: any*/),
        (v18/*: any*/),
        (v19/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Person",
      "kind": "LinkedField",
      "name": "assignedPersons",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        (v13/*: any*/),
        (v14/*: any*/),
        (v20/*: any*/),
        (v15/*: any*/),
        (v16/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "email",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": "timeRegistrations",
      "args": null,
      "concreteType": "TimeRegTypeConnection",
      "kind": "LinkedField",
      "name": "__Task_timeRegistrations_connection",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "TimeRegTypeEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "TimeRegType",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "invoiced",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "xeroInvoiceId",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "minutesRegistered",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "lockedInPeriod",
                  "storageKey": null
                },
                (v22/*: any*/)
              ],
              "storageKey": null
            },
            (v23/*: any*/)
          ],
          "storageKey": null
        },
        (v24/*: any*/)
      ],
      "storageKey": null
    },
    (v20/*: any*/),
    {
      "alias": "googleDriveFiles",
      "args": null,
      "concreteType": "GoogleDriveFileTypeConnection",
      "kind": "LinkedField",
      "name": "__Task_googleDriveFiles_connection",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "GoogleDriveFileTypeEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "GoogleDriveFile",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                (v1/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "link",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "thumb",
                  "storageKey": null
                },
                (v22/*: any*/)
              ],
              "storageKey": null
            },
            (v23/*: any*/)
          ],
          "storageKey": null
        },
        (v24/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": "files",
      "args": null,
      "concreteType": "FileTypeConnection",
      "kind": "LinkedField",
      "name": "__Task_files_connection",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "FileTypeEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "File",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                (v1/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "mimeType",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "key",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "size",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "yearCreated",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "monthCreated",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "dayCreated",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hourCreated",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "minuteCreated",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "secondCreated",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Person",
                  "kind": "LinkedField",
                  "name": "person",
                  "plural": false,
                  "selections": [
                    (v0/*: any*/),
                    (v29/*: any*/)
                  ],
                  "storageKey": null
                },
                (v22/*: any*/)
              ],
              "storageKey": null
            },
            (v23/*: any*/)
          ],
          "storageKey": null
        },
        (v24/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "commentCount",
      "storageKey": null
    },
    {
      "alias": "comments",
      "args": null,
      "concreteType": "CommentTypeConnection",
      "kind": "LinkedField",
      "name": "__Task_comments_connection",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "CommentTypeEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "CommentType",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "comment",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "year",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "month",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "day",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hours",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "minutes",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "seconds",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Person",
                  "kind": "LinkedField",
                  "name": "person",
                  "plural": false,
                  "selections": [
                    (v0/*: any*/),
                    (v13/*: any*/),
                    (v14/*: any*/),
                    (v29/*: any*/),
                    (v15/*: any*/),
                    (v16/*: any*/)
                  ],
                  "storageKey": null
                },
                (v22/*: any*/)
              ],
              "storageKey": null
            },
            (v23/*: any*/)
          ],
          "storageKey": null
        },
        (v24/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "createdAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Person",
      "kind": "LinkedField",
      "name": "createdBy",
      "plural": false,
      "selections": (v30/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "latestUiUpdateAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Person",
      "kind": "LinkedField",
      "name": "latestUiUpdateBy",
      "plural": false,
      "selections": (v30/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Person",
      "kind": "LinkedField",
      "name": "owner",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        (v13/*: any*/),
        (v14/*: any*/),
        (v29/*: any*/),
        (v15/*: any*/),
        (v16/*: any*/),
        (v20/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ProjectType",
      "kind": "LinkedField",
      "name": "project",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        (v1/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "useTaskOwner",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "useTaskFollowers",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "useTaskHierarchy",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "projectStartYear",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "projectStartMonth",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "projectStartDay",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "projectEndYear",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "projectEndMonth",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "projectEndDay",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "status",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "projectColor",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isJiraProject",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "jiraSubtaskType",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "JiraCloudProjectType",
          "kind": "LinkedField",
          "name": "jiraCloudProject",
          "plural": false,
          "selections": (v2/*: any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "jiraCloudEpicIds",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "JiraServerProjectType",
          "kind": "LinkedField",
          "name": "jiraServerProject",
          "plural": false,
          "selections": (v2/*: any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "gitlabProjectName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "gitlabServerProjectName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "projectGroupId",
          "storageKey": null
        },
        (v4/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "taskLevels",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "companyProjectId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "customProjectId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isProgramRevenueLocked",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "programBudgetType",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "ProgramType",
          "kind": "LinkedField",
          "name": "program",
          "plural": false,
          "selections": [
            (v1/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "prefix",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "budgetType",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "ProjectServiceProgramMemberTypeConnection",
              "kind": "LinkedField",
              "name": "members",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "ProjectServiceProgramMemberTypeEdge",
                  "kind": "LinkedField",
                  "name": "edges",
                  "plural": true,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "ProjectServiceProgramMemberType",
                      "kind": "LinkedField",
                      "name": "node",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "role",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "Person",
                          "kind": "LinkedField",
                          "name": "person",
                          "plural": false,
                          "selections": (v2/*: any*/),
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "HarvestProjectType",
          "kind": "LinkedField",
          "name": "harvestProject",
          "plural": false,
          "selections": (v2/*: any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "manualProgressOnProjectEnabled",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "manualProgressOnPhasesEnabled",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "manualProgressOnTasksEnabled",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "vstsProject",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "vstsAccount",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "vstsTwoWaySync",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "sprintTimeBox",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "estimationUnit",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "remainingAutoCalculated",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "RateCard",
          "kind": "LinkedField",
          "name": "rateCard",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": "Role",
              "kind": "LinkedField",
              "name": "disabledRoles",
              "plural": true,
              "selections": (v2/*: any*/),
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": "projectPersons",
          "args": null,
          "concreteType": "ProjectPersonTypeConnection",
          "kind": "LinkedField",
          "name": "__Project_projectPersons_connection",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "ProjectPersonTypeEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "ProjectPerson",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    (v0/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "Person",
                      "kind": "LinkedField",
                      "name": "person",
                      "plural": false,
                      "selections": [
                        (v0/*: any*/),
                        (v13/*: any*/),
                        (v14/*: any*/),
                        (v29/*: any*/),
                        (v15/*: any*/),
                        (v16/*: any*/),
                        (v21/*: any*/),
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "permissions",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "harvestUser",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "ProjectType",
                      "kind": "LinkedField",
                      "name": "project",
                      "plural": false,
                      "selections": (v2/*: any*/),
                      "storageKey": null
                    },
                    (v20/*: any*/),
                    (v22/*: any*/)
                  ],
                  "storageKey": null
                },
                (v23/*: any*/)
              ],
              "storageKey": null
            },
            (v24/*: any*/)
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Client",
          "kind": "LinkedField",
          "name": "client",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            (v1/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "logoId",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "logoDefaultId",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": (v31/*: any*/),
          "concreteType": "PhaseTypeConnection",
          "kind": "LinkedField",
          "name": "phases",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PhaseTypeEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "PhaseType",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    (v0/*: any*/),
                    (v1/*: any*/),
                    (v5/*: any*/),
                    (v6/*: any*/),
                    (v7/*: any*/),
                    (v11/*: any*/),
                    (v10/*: any*/),
                    (v9/*: any*/)
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": "phases(first:10000)"
        },
        {
          "alias": null,
          "args": [
            {
              "kind": "Literal",
              "name": "first",
              "value": 1000000
            }
          ],
          "concreteType": "StatusColumnV2TypeConnection",
          "kind": "LinkedField",
          "name": "statusColumnsV2",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "StatusColumnV2TypeEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "StatusColumnV2",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    (v0/*: any*/),
                    (v1/*: any*/),
                    (v25/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "order",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "jiraStatusId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "adoState",
                      "storageKey": null
                    },
                    (v28/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "StatusColumnUserActions",
                      "kind": "LinkedField",
                      "name": "userActions",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "canDelete",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "canDeleteWithTasks",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "canCreateTask",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "canRename",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": "statusColumnsV2(first:1000000)"
        },
        {
          "alias": null,
          "args": (v31/*: any*/),
          "concreteType": "SprintTypeConnection",
          "kind": "LinkedField",
          "name": "sprints",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "SprintTypeEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Sprint",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    (v0/*: any*/),
                    (v1/*: any*/),
                    (v5/*: any*/),
                    (v6/*: any*/),
                    (v7/*: any*/),
                    (v19/*: any*/),
                    (v18/*: any*/),
                    (v17/*: any*/)
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": "sprints(first:10000)"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "DeprecatedProjectIndicatorJS_project"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Task"
};
})();
(node as any).hash = 'ffaa86a86d5c20fb87c1e5cd8d448d10';
export default node;
